export default __webpack_public_path__ + "static/media/Course-Default.2ef1f11a.svg";